import { Button, Input, Space, Table } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { P1P2Contenxt } from "../..";

const PList = ({ type }) => {
  const {
    dataSource,
    kpis = {
      loading: false,
      data: [],
    },
    provinces = { loading: false, data: [] },
  } = useContext(P1P2Contenxt);

  const [dataSet, setDataSet] = useState([]);
  const [filtredDataSet, setFiltredDataSet] = useState([]);
  const [columns, setColumns] = useState([]);
  const [search, setSearch] = useState({
    searchText: "",
    searchedColumn: "",
  });

  useEffect(() => {
    if (
      dataSource[type] &&
      !dataSource[type].loading &&
      dataSource[type].data &&
      provinces &&
      kpis
    ) {
      if (
        dataSource[type].data.list2 &&
        dataSource[type].data.list2.length > 0 &&
        !provinces.loading &&
        !kpis.loading
      ) {
        const d = dataSource[type].data.list2;
        setFiltredDataSet(d);
        setDataSet(d);

        let tmpColumns = [];
        const {
          _id,
          read,
          __v,
          SITENAME,
          SUBREGION,
          TECH,
          REGION,
          PROVINCE,
          CITY,
          KPI,
          Priority,
          Park,
          ...row
        } = dataSource[type].data.list2[0];

        const rows = Object.keys(row);

        tmpColumns = [
          ...tmpColumns,
          {
            key: "SITENAME",
            title: "SITENAME",
            dataIndex: "SITENAME",
            className: "whitespace-nowrap",
            ...getColumnSearchProps("SITENAME"),
            sorter: (a, b) =>
              +(a["SITENAME"] > b["SITENAME"]) ||
              -(a["SITENAME"] < b["SITENAME"]),
            sortDirections: ["descend", "ascend"],
          },
          {
            key: "SUBREGION",
            title: "SUBREGION",
            dataIndex: "SUBREGION",
            className: "whitespace-nowrap",
            ...getColumnSearchProps("SUBREGION"),
            sorter: (a, b) =>
              +(a["SUBREGION"] > b["SUBREGION"]) ||
              -(a["SUBREGION"] < b["SUBREGION"]),
            sortDirections: ["descend", "ascend"],
          },
          {
            key: "TECH",
            title: "TECH",
            dataIndex: "TECH",
            className: "whitespace-nowrap",
            filters: [
              {
                text: "2G",
                value: "2G",
              },
              {
                text: "3G",
                value: "3G",
              },
              {
                text: "4G",
                value: "4G",
              },
              {
                text: "TDD",
                value: "TDD",
              },
              {
                text: "FDD",
                value: "FDD",
              },
            ],
            filterResetToDefaultFilteredValue: true,
            onFilter: (value, record) =>
              record["TECH"]
                ? record["TECH"]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
            sorter: (a, b) =>
              +(a["TECH"] > b["TECH"]) || -(a["TECH"] < b["TECH"]),
            sortDirections: ["descend", "ascend"],
          },
          {
            key: "REGION",
            title: "REGION",
            dataIndex: "REGION",
            className: "whitespace-nowrap",
            filters: [
              {
                text: "R1",
                value: "R1",
              },
              {
                text: "R3",
                value: "R3",
              },
              {
                text: "R7",
                value: "R7",
              },
              {
                text: "R8",
                value: "R8",
              },
            ],
            filterResetToDefaultFilteredValue: true,
            onFilter: (value, record) =>
              record["REGION"]
                ? record["REGION"]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
            sorter: (a, b) =>
              +(a["REGION"] > b["REGION"]) || -(a["REGION"] < b["REGION"]),
            sortDirections: ["descend", "ascend"],
          },
          {
            key: "PROVINCE",
            title: "PROVINCE",
            dataIndex: "PROVINCE",
            className: "whitespace-nowrap",
            filterResetToDefaultFilteredValue: true,
            filters: [
              ...provinces.data.map((p) => ({
                text: p.label,
                value: p.value,
              })),
            ],
            onFilter: (value, record) =>
              record["PROVINCE"]
                ? record["PROVINCE"]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
            sorter: (a, b) =>
              +(a["PROVINCE"] > b["PROVINCE"]) ||
              -(a["PROVINCE"] < b["PROVINCE"]),
            sortDirections: ["descend", "ascend"],
          },
          {
            key: "CITY",
            title: "CITY",
            dataIndex: "CITY",
            className: "whitespace-nowrap",
            ...getColumnSearchProps("CITY"),
            sorter: (a, b) =>
              +(a["CITY"] > b["CITY"]) || -(a["CITY"] < b["CITY"]),
            sortDirections: ["descend", "ascend"],
          },
          {
            key: "KPI",
            title: "KPI",
            dataIndex: "KPI",
            className: "whitespace-nowrap",
            filterResetToDefaultFilteredValue: true,
            filters: [
              ...kpis.data.map((k) => ({
                text: k.label,
                value: k.value,
              })),
            ],
            onFilter: (value, record) =>
              record["KPI"]
                ? record["KPI"]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
            sorter: (a, b) => +(a["KPI"] > b["KPI"]) || -(a["KPI"] < b["KPI"]),
            sortDirections: ["descend", "ascend"],
          },
          {
            key: "Priority",
            title: "Priority",
            dataIndex: "Priority",
            className: "whitespace-nowrap",
            filterResetToDefaultFilteredValue: true,
            filters: [
              {
                text: "P1",
                value: "P1",
              },
              {
                text: "P2",
                value: "P2",
              },
            ],
            onFilter: (value, record) =>
              record["Priority"]
                ? record["Priority"]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
            sorter: (a, b) =>
              +(a["Priority"] > b["Priority"]) ||
              -(a["Priority"] < b["Priority"]),
            sortDirections: ["descend", "ascend"],
          },
          {
            key: "Park",
            title: "Park",
            dataIndex: "Park",
            className: "whitespace-nowrap",
            render: (v) => (
              <>{v.toString() === "0" ? "Not Parked" : "Parked"}</>
            ),
            filterResetToDefaultFilteredValue: true,
            filters: [
              {
                text: "Not Parked",
                value: "0",
              },
              {
                text: "Parked",
                value: "1",
              },
            ],
            onFilter: (value, record) =>
              record["Park"]
                ? record["Park"].toString() === value.toString()
                : "",
            sorter: (a, b) =>
              +(a["Park"] > b["Park"]) || -(a["Park"] < b["Park"]),
            sortDirections: ["descend", "ascend"],
          },
        ];

        rows.forEach((key) =>
          tmpColumns.push({
            key: key,
            title: key,
            dataIndex: key,
            className: "whitespace-nowrap",
            ...getColumnSearchProps(key),
            sorter: (a, b) => +(a[key] > b[key]) || -(a[key] < b[key]),
            sortDirections: ["descend", "ascend"],
          })
        );
        setColumns([...tmpColumns]);
      }
    }
  }, [dataSource, provinces, kpis]);

  function getColumnSearchProps(dataIndex) {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              search.searchInput = node;
            }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => handleReset(clearFilters)}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                confirm({ closeDropdown: false });
                setSearch({
                  searchText: selectedKeys[0],
                  searchedColumn: dataIndex,
                });
              }}
            >
              Filter
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : "",
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => search.searchInput.select(), 100);
        }
      },
      render: (text) =>
        search.searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[search.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    };
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearch({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearch({ searchText: "" });
  };

  const handleChange = (pagination, filters, sorter, { currentDataSource }) => {
    console.log(filters);
    setFiltredDataSet(currentDataSource);
  };

  return (
    <div className="pt-0 px-4">
      <Table
        scroll={{ scrollToFirstRowOnChange: true, x: "480px" }}
        onChange={handleChange}
        dataSource={[...dataSet]}
        loading={dataSource[type].loading}
        columns={[...columns]}
        rowKey="_id"
        tableLayout="auto"
      />
    </div>
  );
};

export default PList;
